import { useCallback } from 'react';
import { TrackerPromptData } from './promptsViewedContext';

/**
 * Обработчик попадания карточки на экран, который включает видео.
 */
export function usePlayVideo() {
    const handleVideoPlay = useCallback((entry: IntersectionObserverEntry, data?: TrackerPromptData) => {
        if (!data?.videoRef?.current) {
            return;
        }

        data.videoRef.current.play();
    }, []);

    const handleVideoStop = useCallback((entry: IntersectionObserverEntry, data?: TrackerPromptData) => {
        if (!data?.videoRef?.current) {
            return;
        }

        data.videoRef.current.pause();
        data.videoRef.current.currentTime = 0;
    }, []);

    return [handleVideoPlay, handleVideoStop];
}
